import React, { useContext } from 'react';
import {
	IGameAssignmentContext,
	GameAssignmentContext,
} from '../../../../../gameAssignmentState/gameAssignmentContext';
import SearchField from 'components/SearchField/SearchField';
import style from './Search.module.scss';

const Search: React.FC = () => {
	const { changeSearchString, searchString } = useContext<IGameAssignmentContext>(GameAssignmentContext);

	return (
		<div className={style.container}>
			<SearchField onChangeSelectSearchString={changeSearchString} searchString={searchString} delay={800} />
		</div>
	);
};

export default Search;
